import Question from "../interfaces/Question";

const questionData: Question[] = [
	{
		id: "0",
		text: "Favorite Holiday Drink",
		options: [
			{
				id: 0,
				text: "Hot Cocoa",
				image: "https://images.unsplash.com/photo-1606423125989-d745da36eb05?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8aG90JTIwY29jb2F8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
			},
			{
				id: 1,
				text: "Egg Nog",
				image: "https://images.unsplash.com/photo-1619290463537-01382d613aa2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8ZWdnJTIwbm9nfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
			}
		]
	},
	{
		id: "1",
		text: "Favorite Classic Cartoon",
		options: [
			{
				id: 0,
				text: "Rudolf",
				image: "https://images.unsplash.com/photo-1479740030693-66ad10f3a7b0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cnVkb2xwaHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
			},
			{
				id: 1,
				text: "Frosty",
				image: "https://images.unsplash.com/photo-1606770515086-ede533831581?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8c25vd21hbnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
			}
		]
	},
	{
		id: "2",
		text: "Christmas Soundtrack",
		options: [
			{
				id: 0,
				text: "Mariah Carey",
				image: "https://upload.wikimedia.org/wikipedia/en/8/84/Merry_Christmas_Mariah_Carey.png"
			},
			{
				id: 1,
				text: "Michael Buble",
				image: "https://m.media-amazon.com/images/I/61M3mNpxJML._SL1200_.jpg"
			}
		]
	},
	{
		id: "3",
		text: "Favorite Place",
		options: [
			{
				id: 0,
				text: "In The Snow",
				image: "https://images.unsplash.com/photo-1477601263568-180e2c6d046e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjB8fHNub3d8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
			},
			{
				id: 1,
				text: "By The Fire",
				image: "https://images.unsplash.com/photo-1631941150945-837cb81fc7e2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGZpcmVwbGFjZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
			}
		]
	},
	{
		id: "4",
		text: "Christmas Tree",
		options: [
			{
				id: 0,
				text: "Real Tree",
				image: "https://images.unsplash.com/photo-1482003297000-b7663a1673f1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8Y2hyaXN0bWFzJTIwdHJlZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
			},
			{
				id: 1,
				text: "Artificial Tree",
				image: "https://images.unsplash.com/photo-1612979168796-bcae1575b8c5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8Y2hyaXN0bWFzJTIwdHJlZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
			}
		]
	},
	{
		id: "5",
		text: "Gift",
		options: [
			{
				id: 0,
				text: "Presents",
				image: "https://images.unsplash.com/photo-1513885535751-8b9238bd345a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cHJlc2VudHN8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
			},
			{
				id: 1,
				text: "Stockings",
				image: "https://images.unsplash.com/photo-1606050948679-5087f8929aa4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTh8fHN0b2NraW5nc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
			}
		]
	},
	{
		id: "6",
		text: "Christmas Movie",
		options: [
			{
				id: 0,
				text: "Christmas Story",
				image: "https://images.tntdrama.com/tnt/$dyna_params/https%3A%2F%2Fi.cdn.tntdrama.com%2Fassets%2Fimages%2F2017%2F10%2FChristmasStory-2048x1536.jpg"
			},
			{
				id: 1,
				text: "Christmas Vacation",
				image: "https://www.tvguide.com/a/i/2019/12/09/900fe762-01cb-430a-be4d-e84994facc9e/191209-christmas-vacation.jpg"
			}
		]
	},
	{
		id: "7",
		text: "Favorite Grinch",
		options: [
			{
				id: 0,
				text: "Classic Grinch",
				image: "https://www.emmys.com/sites/default/files/styles/slider_images/public/Grinch-Wide-Horizontal-Opening-900x600.jpg?itok=UN0vZ5Aa"
			},
			{
				id: 1,
				text: "Jim Carey",
				image: "https://www.indiewire.com/wp-content/uploads/2018/02/shutterstock_5875878f.jpg"
			}
		]
	},
	{
		id: "8",
		text: "Favorite Dish",
		options: [
			{
				id: 0,
				text: "Turkey",
				image: "https://images.unsplash.com/photo-1574672281706-24413c7e8920?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8dHVya2V5JTIwZm9vZHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
			},
			{
				id: 1,
				text: "Ham",
				image: "https://images.unsplash.com/photo-1609604820237-4cd9638aa43e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDN8fGhhbSUyMGZvb2R8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
			}
		]
	},
	{
		id: "9",
		text: "Favorite Attire",
		options: [
			{
				id: 0,
				text: "Cozy Sweater",
				image: "https://images.unsplash.com/photo-1618333473992-1b420d9b7616?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fGNocmlzdG1hcyUyMHN3ZWF0ZXJ8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
			},
			{
				id: 1,
				text: "Ugly Sweater",
				image: "https://images.unsplash.com/photo-1513936049483-a073fcd54f84?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8Y2hyaXN0bWFzJTIwc3dlYXRlcnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
			}
		]
	},
	{
		id: "10",
		text: "What is Die Hard?",
		options: [
			{
				id: 0,
				text: "Christmas Movie",
				image: "https://bloximages.newyork1.vip.townnews.com/gazette.com/content/tncms/assets/v3/editorial/e/96/e965c5a4-b5b2-5ed8-9a55-3e6deab17de8/5b0383fcbd8b3.image.jpg"
			},
			{
				id: 1,
				text: "Not A Christmas Movie",
				image: "https://www.gannett-cdn.com/media/2020/05/28/USATODAY/usatsports/imageForEntry17-tmg.jpg"
			}
		]
	}
];

export default questionData;
